<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <h6>{{ isClient ? 'Compras' : 'Ventas' }}</h6>

            <div class="row">
              <!-- Columna de búsqueda -->
              <div class="col-md-6 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar remisión..." @input="fetchData(null)" />
              </div>
            </div>

          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      N°</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Tipo doc</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Cliente</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Vendedor</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Teléfono</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Estado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Observación</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Total venta</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Total pagado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Fecha</th>
                    <th v-if="false" class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Siigo</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Kubapp</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.id }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-gradient-secondary">{{ value.tipo_doc_id || '00FE' }}</span>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.name }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ sellerName(value) }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <h6 class="mb-0 text-sm">{{ value.phone }}</h6>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm" :class="remissionStatusClass(value.status)">
                        {{ remissionStatusLabel(value.status) }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        <a @click="viewObservation(value.observation)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                          data-original-title="Registro">
                          <i class="fa fa-comment"></i>
                        </a>
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ formatMoney(saleTotal(value)) }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span
                        class="text-xs font-weight-bold"
                        :class="isPartiallyPaid(value) ? 'text-danger' : 'text-secondary'"
                      >
                        {{ formatMoney(totalPaid(value)) }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ new Date(value.created_at).toLocaleDateString('es-ES') }}
                      </span>
                    </td>
                    <td v-if="false" class="align-middle text-center text-sm">
                      <span
                        v-if="value.siigo_id"
                        class="badge badge-sm bg-gradient-info"
                        :title="value.siigo_id"
                      >
                        Sincronizado
                      </span>
                      <button
                        v-else-if="value.can_sync_siigo"
                        type="button"
                        class="btn btn-sm btn-outline-info py-1 px-2 mb-0"
                        :disabled="syncingId === value.id"
                        @click="syncSiigo(value)"
                      >
                        <i
                          :class="syncingId === value.id ? 'fas fa-sync fa-spin me-1' : 'fas fa-cloud-upload-alt me-1'"
                        ></i>
                        Sincronizar
                      </button>
                      <span v-else class="text-muted text-xs">—</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        v-if="value.kubapp_json"
                        class="badge badge-sm bg-gradient-primary"
                        :title="getKubappDocNumber(value.kubapp_json)"
                      >
                        {{ getKubappDocNumber(value.kubapp_json) }}
                      </span>
                      <button
                        v-else-if="kubappEnabled"
                        type="button"
                        class="btn btn-sm py-1 px-2 mb-0"
                        :class="isKubappSynced(value.id) ? 'btn-success' : 'btn-outline-primary'"
                        :title="isKubappSynced(value.id)
                          ? 'Marcada como sincronizada (clic para desmarcar)'
                          : 'Marcar como sincronizada en Kubapp'"
                        @click="toggleKubappSynced(value.id)"
                      >
                        <i :class="isKubappSynced(value.id) ? 'fas fa-check me-1' : 'fas fa-times me-1'"></i>
                        {{ isKubappSynced(value.id) ? 'Sincronizada' : 'No sincronizada' }}
                      </button>
                      <span v-else class="text-muted text-xs">—</span>
                    </td>
                    <td class="align-middle text-center">
                      <a
                        @click="printRemission(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        data-toggle="tooltip"
                        data-original-title="Imprimir ticket"
                      >
                        <i class="fas fa-ticket-alt"></i>
                      </a>

                      <a
                        @click="viewRemission(value)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;"
                        data-toggle="tooltip"
                        data-original-title="Ver y editar pedido"
                      >
                        <i class="fas fa-eye"></i>
                      </a>

                      <a
                        @click="downloadDeliveryNote(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        :class="{ 'opacity-50 pe-none': deliveryNoteId === value.id }"
                        style="margin-left: 15px;"
                        data-toggle="tooltip"
                        data-original-title="Descargar nota de entrega (PDF)"
                      >
                        <i :class="deliveryNoteId === value.id ? 'fas fa-sync fa-spin' : 'fas fa-file-pdf'"></i>
                      </a>

                      <a
                        v-if="normalizeRemissionStatus(value.status) !== 'aceptado' && !isKubappSynced(value.id)"
                        @click="deleteUser(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;"
                        data-toggle="tooltip"
                        data-original-title="Eliminar registro"
                      >
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="13" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import remissionsService from '@/services/remissions.service';
import { openPosTicketWindow } from '@/utils/posTicketPrint';

export default {
  name: 'ProjectsList',
  data() {
    return {
      searchQuery: '',
      syncingId: null,
      syncingKubappId: null,
      deliveryNoteId: null,
      kubappSyncedIds: [],
      currentUser: null,
    };
  },
  computed: {
    ...mapGetters('remissions', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']),
    ...mapGetters('settings', ['kubappEnabled']),
    isClient() {
      return this.currentUser?.role == '4';
    },
    currentPage() {
      return this.$store.state.remissions.currentPage;
    },
    lastPage() {
      return this.$store.state.remissions.lastPage;
    },
    data() {
      return this.allData;
    },
    links() {
      return this.$store.getters['remissions/links'];
    },
  },
  methods: {
    sellerName(row) {
      if (row?.seller_name) {
        return row.seller_name;
      }
      if (row?.seller?.name) {
        return row.seller.name;
      }
      return '—';
    },
    normalizeRemissionStatus(status) {
      if (status === 0 || status === '0') {
        return 'pendiente';
      }
      if (status === 1 || status === '1') {
        return 'aceptado';
      }
      if (status === 'pendiente' || status === 'aceptado' || status === 'cancelado' || status === 'devolucion') {
        return status;
      }
      return 'aceptado';
    },
    remissionStatusLabel(status) {
      const normalized = this.normalizeRemissionStatus(status);
      if (normalized === 'aceptado') return 'Aceptado';
      if (normalized === 'cancelado') return 'Cancelado';
      if (normalized === 'devolucion') return 'Devolución';
      return 'Pendiente';
    },
    remissionStatusClass(status) {
      const normalized = this.normalizeRemissionStatus(status);
      if (normalized === 'aceptado') return 'bg-success';
      if (normalized === 'cancelado') return 'bg-danger';
      if (normalized === 'devolucion') return 'bg-secondary';
      return 'bg-warning';
    },
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };
      const role = this.currentUser?.role;
      if (role && role !== '1' && role !== 1 && role !== '2' && role !== 2) {
        if (role === '4' || role === 4) {
          params.user_id = this.currentUser.id;
        } else {
          params.seller_id = this.currentUser.id;
        }
      }
      await this.$store.dispatch('remissions/fetchData', params);
    },
    viewObservation(observation) {
      // Mostramos el mensaje en un SweetAlert
      Swal.fire({
        title: 'Observación',
        text: observation || 'No hay observaciones disponibles.',
        icon: 'info',  // Puedes cambiar el icono a info, success, warning, etc.
        confirmButtonText: 'Aceptar'
      });
    },
    saleTotal(row) {
      return parseFloat(row?.total ?? 0) || 0;
    },
    totalPaid(row) {
      return parseFloat(row?.total_paid ?? 0) || 0;
    },
    isPartiallyPaid(row) {
      return this.totalPaid(row) < this.saleTotal(row);
    },
    formatMoney(value) {
      return (Number(value) || 0).toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("remissions/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {
            this.fetchData();
            await Swal.fire(
              'Eliminado!',
              'El registro se ha eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    printRemission(id) {
      openPosTicketWindow(this.$router, id);
    },
    viewRemission(remission) {
      if (!remission?.id) {
        return;
      }
      this.$router.push({
        name: 'Remissions Create',
        query: { id: String(remission.id) },
      });
    },
    async downloadDeliveryNote(id) {
      if (this.deliveryNoteId) return;

      this.deliveryNoteId = id;
      try {
        const response = await remissionsService.getDeliveryNote(id);
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.download = `nota-entrega-${id}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar la nota de entrega.',
        });
      } finally {
        this.deliveryNoteId = null;
      }
    },
    isKubappSynced(id) {
      return this.kubappSyncedIds.includes(Number(id));
    },
    toggleKubappSynced(id) {
      const num = Number(id);
      const idx = this.kubappSyncedIds.indexOf(num);
      if (idx === -1) {
        this.kubappSyncedIds.push(num);
      } else {
        this.kubappSyncedIds.splice(idx, 1);
      }
      localStorage.setItem('kubappSyncedRemissions', JSON.stringify(this.kubappSyncedIds));
    },
    loadKubappSyncedIds() {
      try {
        const raw = localStorage.getItem('kubappSyncedRemissions');
        const arr = raw ? JSON.parse(raw) : [];
        this.kubappSyncedIds = Array.isArray(arr)
          ? arr.map(Number).filter(Number.isFinite)
          : [];
      } catch {
        this.kubappSyncedIds = [];
      }
    },
    getKubappDocNumber(kubappJson) {
      try {
        const parsed = typeof kubappJson === 'string' ? JSON.parse(kubappJson) : kubappJson;
        const result = parsed?.result?.[0] ?? parsed?.result ?? null;
        if (result && result.Documento) {
          return String(result.Documento);
        }
        return 'Sincronizado';
      } catch {
        return 'Sincronizado';
      }
    },
    async syncKubapp(remission) {
      if (!remission?.id || this.syncingKubappId) {
        return;
      }

      const confirm = await Swal.fire({
        title: 'Sincronizar con Kubapp',
        html: `¿Enviar la venta <strong>#${remission.id}</strong> a Kubapp?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sincronizar',
        cancelButtonText: 'Cancelar',
      });

      if (!confirm.isConfirmed) {
        return;
      }

      this.syncingKubappId = remission.id;

      try {
        const response = await remissionsService.syncKubapp(remission.id);
        await Swal.fire({
          icon: 'success',
          title: 'Sincronizado',
          text: response.data?.message || 'Venta enviada a Kubapp correctamente.',
        });
        await this.fetchData();
      } catch (error) {
        const msg =
          error?.response?.data?.message ||
          error?.message ||
          'No se pudo sincronizar la venta con Kubapp.';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: msg,
        });
      } finally {
        this.syncingKubappId = null;
      }
    },
    async syncSiigo(remission) {
      if (!remission?.id || this.syncingId) {
        return;
      }

      const confirm = await Swal.fire({
        title: 'Sincronizar con Siigo',
        html: `¿Enviar la venta <strong>#${remission.id}</strong> a Siigo?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sincronizar',
        cancelButtonText: 'Cancelar',
      });

      if (!confirm.isConfirmed) {
        return;
      }

      this.syncingId = remission.id;

      try {
        const response = await remissionsService.syncSiigo(remission.id);
        await Swal.fire({
          icon: 'success',
          title: 'Sincronizado',
          text: response.data?.message || 'Venta enviada a Siigo correctamente.',
        });
        await this.fetchData();
      } catch (error) {
        const msg =
          error?.response?.data?.message ||
          error?.message ||
          'No se pudo sincronizar la venta con Siigo.';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: msg,
        });
      } finally {
        this.syncingId = null;
      }
    },
  },
  mounted() {
    this.currentUser = JSON.parse(localStorage.getItem('user') || 'null');
    this.loadKubappSyncedIds();
    this.$store.dispatch('settings/get').catch(() => {});
    this.fetchData();
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}
</style>
